import { Injectable } from '@angular/core';

import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class CountryReferenceService extends BaseReferenceService {
  constructor() {
    super('CountryReference');
  }
}
